module.exports = __webpack_public_path__ + "ve.43cf884596e12e3626ba.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ve.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ve.svg
// module chunks = styles